// extracted by mini-css-extract-plugin
export default {"container":"WrMll","direction":"lwkvM","outlined_badge":"u4Hd9"};